<template>
    <div id="calendar">
        <Banner title="學術活動" :breadcrumbs="breadcrumbs" type="activity"></Banner>
        <div class="container">
            <div class="center_title">
                <Title en="Calendar" chtFirst="行事曆/" chtSecond="學術活動" :center="true"></Title>
            </div>
            <section class="box">
                <div class="left">
                    <div class="color">
                        <div class="item" v-for="(i,index) in colors" :key="index">
                            <div class="block" :class="i.Color"></div>
                            <div class="name">{{i.Name}}</div>
                        </div>
                    </div>
                    <div class="calendar">
                        <full-calendar
                            :events="fcEvents"
                            lang="zh"
                            @eventClick="showEvent"
                            @changeMonth="changeMonth"
                        ></full-calendar>
                        <a
                            class="event_popup animated fadeInDown"
                            ref="popup"
                            v-show="eventId"
                            :href="`/Academic/Activity?Id=${eventId}`"
                        >
                            <div class="time">{{showEventData.Title}}</div>
                            <!-- <div class="title">{{showEventData.Title}}</div> -->
                            <div class="image">
                                <img
                                    :src="showEventData.Image || require('@/assets/default-big.png')"
                                />
                            </div>
                            <div class="info">
                                <div class="icon icon-calendar"></div>
                                <span>{{showEventData.Date}}</span>
                            </div>
                            <div class="info" v-if="showEventData.Position">
                                <div class="icon icon-place"></div>
                                <span>{{showEventData.Position}}</span>
                            </div>
                            <div class="info" v-if="showEventData.Organizer">
                                <div class="icon icon-organizer"></div>
                                <span>{{showEventData.Organizer}}</span>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="right">
                    <div class="title">本月活動資訊</div>
                    <div class="list">
                        <LsitCard
                            v-for="(event,index) in events"
                            :key="index"
                            :event="event"
                            :little="true"
                            :categoryList="categrory"
                        ></LsitCard>
                        <div class="remark" v-if="events.length == 0">本月暫無活動</div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import LsitCard from "@/components/listCard";
import API from "@/service/activity";
export default {
    name: "Calendar",
    components: {
        LsitCard
    },
    props: ["activities"],
    data() {
        return {
            breadcrumbs: [
                {
                    url: "/",
                    title: "首頁"
                },
                {
                    title: "學術活動"
                },
                {
                    url: "/Academic/Calendar",
                    title: "行事曆"
                }
            ],
            colors: [],
            events: [
                // {
                //     Id: "9acaddasdhhyth",
                //     Type: "International",
                //     Image: require("@/assets/dev/img1.png"),
                //     Category: "國際活動International Activities",
                //     Title: "APAO 2019",
                //     Date: "2019-03-01",
                //     StartTime: "1551369600",
                //     Position: "Bangkok Thailand",
                //     Organizer: "",
                //     Submission: "",
                //     Number: ""
                // },
                // {
                //     Id: "134dfy56yyuk",
                //     Type: "Domestic",
                //     Image: require("@/assets/dev/img2.png"),
                //     Category: "國內活動Domestic Activies",
                //     Title: "視網膜學會108年第一次<南區>醫師繼續教育",
                //     Date: "2019-03-01 ~ 2019-03-02",
                //     StartTime: "1551369600",
                //     Position: "高雄長坑紀念醫院-湖畔星光1樓星光聽",
                //     Organizer: "",
                //     Submission: "",
                //     Number: ""
                // },
                // {
                //     Id: "1231sdfs756887i",
                //     Type: "Annual",
                //     Image: require("@/assets/dev/img3.png"),
                //     Category: "年會 Annual Meetings",
                //     Title: "第59次年度學術研討會",
                //     Date: "2019-03-01",
                //     StartTime: "1551369600",
                //     Position: "台大醫院國際會議中心",
                //     Organizer: "中華民國眼科醫學會",
                //     Submission: "2018/06/20~2018/08/03",
                //     Number: "168888"
                // },
                // {
                //     Id: "123sdfsdfrt",
                //     Type: "Mid",
                //     Image: require("@/assets/dev/img2.png"),
                //     Category: "地會Mid-Year Meetings",
                //     Title: "第54次學術研討會",
                //     Date: "2019-03-01",
                //     StartTime: "1551369600",
                //     Position: "台南大億麗緻酒店",
                //     Organizer: "中台南奇美醫院永康院區眼科部",
                //     Submission: "2019-01-07~2019-02-13",
                //     Number: "107059"
                // },
                // {
                //     Id: "12f567usdfsa",
                //     Type: "International",
                //     Image: require("@/assets/dev/img3.png"),
                //     Category: "國際活動International Activities",
                //     Title: "APAO 2019",
                //     Date: "2019-03-01",
                //     StartTime: "1551369600",
                //     Position: "Bangkok Thailand",
                //     Organizer: "中華民國眼科醫學會",
                //     Submission: "2018/06/20~2018/08/03",
                //     Number: "107059"
                // }
            ],
            fcEvents: [
                // {
                //     title: "每日金句",
                //     start: "2019-07-25",
                //     end: "2019-07-27",
                //     YOUR_DATA: {
                //         Id: "31231231",
                //         Time: "6:00pm",
                //         Image: "/static/images/activity/act01.jpg",
                //         Location: "高雄長坑紀念醫院-湖畔星光1樓星光聽"
                //     },
                //     cssClass: ["international"]
                // },
                // {
                //     title: "每日活動-視網膜~",
                //     start: "2019-06-24",
                //     end: "2019-06-27",
                //     YOUR_DATA: {
                //         Id: "122312",
                //         Time: "10:00am",
                //         Image: "/static/images/activity/act02.jpg",
                //         Location: "高雄長坑紀念醫院-湖畔星光2樓菇菇聽"
                //     },
                //     cssClass: ["domestic"]
                // },
                // {
                //     title: "今日聚餐",
                //     start: "2019-06-11",
                //     end: "2019-06-12",
                //     YOUR_DATA: {
                //         Id: "5595",
                //         Time: "9:00pm",
                //         Image: "/static/images/activity/act03.jpg",
                //         Location: "高雄長坑紀念醫院-湖畔星光8樓禿子聽"
                //     },
                //     cssClass: ["annual"]
                // },
                // {
                //     title: "每日焦點",
                //     start: "2019-06-01",
                //     end: "2019-06-03",
                //     YOUR_DATA: {
                //         Id: "22a1sd",
                //         Time: "8:00pm",
                //         Image: "/static/images/activity/act04.jpg",
                //         Location: "高雄長坑紀念醫院-湖畔星光5樓金孫聽"
                //     },
                //     cssClass: ["mid_year"]
                // }
            ],
            showEventData: {
                Title: "",
                Image: "",
                Date: "",
                Position: "",
                Organizer: ""
            },
            eventId: "",
            pos: {
                top: "",
                left: ""
            },
            isPhone: false,
            Month: "",
            categrory: [],
            callApi: false
        };
    },
    methods: {
        showEvent(params, jsEvent, pos) {
            const vm = this;
            if (vm.isPhone) {
                location.href = `/Academic/Activity?Id=${params.YOUR_DATA.Id}`;
                return false;
            }
            let el = this.$refs.popup;
            if (vm.eventId == params.YOUR_DATA.Id) {
                if (vm.pos.top == pos.top && vm.pos.left == pos.left) {
                    vm.eventId = "";
                    vm.pos = {
                        top: "",
                        left: ""
                    };
                    return false;
                }
            }
            vm.pos = pos;
            if (vm.eventId == "") {
                vm.eventId = params.YOUR_DATA.Id;
            }
            vm.eventId = params.YOUR_DATA.Id;
            vm.$set(vm.showEventData, "Time", params.YOUR_DATA.Time);
            vm.$set(vm.showEventData, "Title", params.title);
            vm.$set(vm.showEventData, "Image", params.YOUR_DATA.Image);
            vm.$set(vm.showEventData, "Date", params.start + "~" + params.end);
            vm.$set(vm.showEventData, "Organizer", params.YOUR_DATA.Organizer);
            vm.$set(vm.showEventData, "Position", params.YOUR_DATA.Location);
            //   console.log("可套用的function", jsEvent);

            el.style.top = pos.top - 250 + "px";
            // console.log(pos.left);
            let Left = document.body.clientWidth / 40;
            el.style.left = pos.left - Left + "px";
        },
        changeMonth(start, end, current) {
            const vm = this;
            if (!vm.callApi) {
                vm.callApi = true;
                return false;
            }
            //關掉popup
            vm.eventId = "";
            vm.pos = {
                top: "",
                left: ""
            };
            let NowMonth = parseInt(vm.$moment(current).format("MM"));
            // console.log(NowMonth);
            if (NowMonth == 1) {
                document.querySelectorAll(".prev-month")[0].style.display =
                    "none";
            } else {
                document.querySelectorAll(".prev-month")[0].style.display =
                    "inline";
            }

            if (NowMonth == 12) {
                document.querySelectorAll(".next-month")[0].style.display =
                    "none";
            } else {
                document.querySelectorAll(".next-month")[0].style.display =
                    "inline";
            }
            API.getActivityListMonth({ Month: NowMonth }).then(result => {
                if (result.Ok) {
                    // vm.events = res.Data.Activities;
                    let Arr = [];
                    new Promise((res, rj) => {
                        result.Data.Activities.forEach(item => {
                            let obj = {
                                title: "",
                                start: "",
                                end: "",
                                YOUR_DATA: {
                                    Id: "",
                                    Time: "",
                                    Image: "",
                                    Location: ""
                                },
                                cssClass: []
                            };
                            obj.title = item.Title;
                            obj.start = vm
                                .$moment(item.RegisterStartOn)
                                .format("YYYY-MM-DD");
                            obj.end = vm
                                .$moment(item.RegisterEndOn)
                                .format("YYYY-MM-DD");
                            obj.YOUR_DATA = {
                                Id: item.Id,
                                Time: vm
                                    .$moment(item.RegisterStartOn)
                                    .format("HH:mm"),
                                Location: item.Location,
                                Image: item.Image,
                                Organizer: item.Organizer
                            };
                            vm.colors.forEach(categrory => {
                                if (categrory.Id == item.CategoryId) {
                                    obj.cssClass = [categrory.Color];
                                }
                            });

                            Arr.push(obj);
                            res(Arr);
                        });
                    }).then(data => {
                        // console.log("本月活動", data);
                        vm.fcEvents = data;
                    });
                }
            });
        }
    },
    computed: {},
    created() {
        const vm = this;
        //判斷裝置
        const sUserAgent = navigator.userAgent.toLowerCase();
        const bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
        const bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
        const bIsMidp = sUserAgent.match(/midp/i) == "midp";
        const bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
        const bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
        const bIsAndroid = sUserAgent.match(/android/i) == "android";
        const bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
        const bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";

        if (
            bIsIpad ||
            bIsIphoneOs ||
            bIsMidp ||
            bIsUc7 ||
            bIsUc ||
            bIsAndroid ||
            bIsCE ||
            bIsWM
        ) {
            vm.isPhone = true;
        }
        if (process.env.NODE_ENV === "production") {
            API.getActivityCategory().then(res => {
                if (res.Ok) {
                    let arr = [];
                    vm.categrory = arr.concat(res.Data);
                    let obj = JSON.parse(vm.activities);
                    vm.events = obj.Activities;
                    vm.colors = vm.categrory.map((categroy, index) => {
                        categroy.Color = `calendar_color${index}`;
                        return categroy;
                    });
                    new Promise((res, rj) => {
                        obj.Activities.forEach(item => {
                            let obj = {
                                title: "",
                                start: "",
                                end: "",
                                YOUR_DATA: {
                                    Id: "",
                                    Time: "",
                                    Image: "",
                                    Location: ""
                                },
                                cssClass: []
                            };
                            obj.title = item.Title;
                            obj.start = vm
                                .$moment(item.RegisterStartOn)
                                .format("YYYY-MM-DD");
                            obj.end = vm
                                .$moment(item.RegisterEndOn)
                                .format("YYYY-MM-DD");
                            obj.YOUR_DATA = {
                                Id: item.Id,
                                Time: vm
                                    .$moment(item.RegisterStartOn)
                                    .format("HH:mm"),
                                Location: item.Location,
                                Image: item.Image,
                                Organizer: item.Organizer
                            };
                            vm.colors.forEach(categrory => {
                                if (categrory.Id == item.CategoryId) {
                                    obj.cssClass = [categrory.Color];
                                }
                            });
                            // console.log(obj);
                            arr.push(obj);
                            res(arr);
                        });
                    }).then(data => {
                        vm.fcEvents = data;
                    });
                }
            });
        } else {
            vm.colors = [
                {
                    Color: "calendar_color0",
                    Name: "國際活動"
                },
                {
                    Color: "calendar_color1",
                    Name: "國內活動"
                },
                {
                    Color: "calendar_color2",
                    Name: "年會"
                },
                {
                    Color: "calendar_color3",
                    Name: "地會"
                }
            ];
        }
    },
    mounted() {},
    watch: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  scoped>
#calendar {
    margin-bottom: 60px;
}
#calendar .box {
    background-color: #eee;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    padding: 20px 0;
}
#calendar .box .left {
    width: 75%;
    padding: 0 7.5px 0 15px;
}
#calendar .box .left .color {
    display: flex;
    /* justify-content: space-between; */
    align-items: center;
    margin-bottom: 20px;
}
#calendar .box .left .color .item {
    display: flex;
    align-items: center;
    padding-right: 20px;
}
#calendar .box .left .color .item .block {
    width: 32px;
    height: 32px;
    border-radius: 32px;
    margin-right: 15px;
}
#calendar .box .left .calendar {
    position: relative;
}
#calendar .box .right {
    width: 25%;
    padding: 0 15px 0 7.5px;
}
#calendar .box .right .title {
    font-size: 1.3rem;
    padding: 5px 0;
    height: 32px;
    text-align: center;
    color: #ee8b59;
    margin-bottom: 20px;
}
#calendar .box .right .remark {
    text-align: center;
    color: #666;
}
.event_popup {
    display: block;
    width: 250px;
    min-height: 360px;
    position: absolute;
    transition: 0.5s;
    padding: 10px;
    margin: auto;
    z-index: 98;
    background-color: #eee;
    border-radius: 5px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
    text-decoration: none;
}
.event_popup::after {
    content: "";
    position: absolute;
    bottom: -14px;
    left: 0;
    right: 0;
    margin: auto;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 15px 10px 0 10px;

    border-color: #eee transparent transparent transparent;
}
.event_popup .time {
    background: #808081;
    padding: 5px 10px;
    line-height: 1.5;
    margin-bottom: 10px;
    border-radius: 5px;
    color: #fff;
    display: inline-block;
    letter-spacing: 3px;
    font-weight: normal;
    font-size: 0.8rem;
}
.event_popup .title {
    width: 100%;
    line-height: 1.5;
    padding: 8px 0;
}
.event_popup .image {
    width: 100%;
    font-size: 0;
    height: 150px;
}
.event_popup .image img {
    width: 100%;
    max-height: 100%;
}
.event_popup .info {
    display: flex;
    /* align-items: center; */
    padding: 5px 0;
    line-height: 1.5;
    color: #666;
}
.event_popup .info .icon {
    padding-right: 8px;
}
@media screen and (max-width: 1200px) {
    #calendar .box .left {
        width: 100%;
        padding: 0;
    }
    #calendar .box .left .color {
        justify-content: space-between;
        padding: 0 8px;
        margin: 30px auto;
        max-width: 960px;
    }
    #calendar .box .left .color .item {
        padding: 0;
    }
    #calendar .box .left .calendar {
        padding: 0 5px;
    }
    #calendar .box .right {
        width: 100%;
        margin-top: 40px;
        padding: 0 5px;
    }
}
@media screen and (max-width: 768px) {
}
</style>



// WEBPACK FOOTER //
// src/pages/calendar.vue